import {
  getDefaultClient,
  getWalletProviderFromWalletAccount,
} from '@dynamic-labs-sdk/client/core';

import { NotSuiProviderError } from '../errors/NotSuiProviderError';
import { isSuiWalletProvider } from '../isSuiWalletProvider';
import type { SuiWalletAccount } from '../SuiWalletAccount.types';

type GetSuiClientParams = {
  walletAccount: SuiWalletAccount;
};

/**
 * Retrieves a SuiClient from a wallet account.
 *
 * @param params.walletAccount - The wallet account to get the SuiClient for.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves to a SuiClient instance
 * @throws NotSuiProviderError If the wallet account's provider is not a SUI provider
 */
export const getSuiClient = async (
  { walletAccount }: GetSuiClientParams,
  client = getDefaultClient()
) => {
  const provider = getWalletProviderFromWalletAccount(
    {
      walletAccount,
    },
    client
  );

  if (!isSuiWalletProvider(provider)) {
    throw new NotSuiProviderError({ providerKey: provider.key });
  }

  return provider.getSuiClient({ walletAccount });
};
